import React, { useState, useEffect } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";

import swal from "sweetalert";
import { useTranslation } from "react-i18next";
import * as api from "../../../actions/api";
import EmailSmsTemplateFormData from "./EmailSmsTemplateFormData";
import encryptionService from "../../../services/encryptionService";

const AddEmailSmsTemplate = (props) => {
  //console.log(props.pieceOfState);

  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "email-sms-template-entry";

  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

  const [formData, setFormData] = useState({
    EventType: "",
    RoleId: [],
    Receivers: "",
    copySMSTo: "",
    mSubject: "",
    MSG: "",
    TemplateMode: "0",
    DryMode: false,
  });
  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();
  const queryClient = useQueryClient();

  const [open, setOpen] = React.useState(false);
  const [Massage, setMassage] = React.useState(false);

  useQuery(
    ["EmailSmsTemplateEntry", id],
    () =>
      api.getEmailSmsTemplates(id).then((res) => {
        setFormData(res.data);
      }),
    {
      enabled: Boolean(id),
    }
  );

  const { isLoading, mutate } = useMutation(api.SaveEmailSmsTemplate, {
    onSuccess: (data) => {
      //console.log("data: ", data);

      if (data.status == 200) {
        /* api.getAllDropdown('FacilityLocation').then((response) => {
          localStorage.setItem(
            "FacilityLocation",
            JSON.stringify(response.datalist.FacilityLocation)
          );
        }) */

        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
        queryClient.getQueriesData("location"); //api page name
        props.history.push("/email-sms-template-entry"); //
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
        queryClient.getQueriesData("location"); //api page name
        props.history.push("/email-sms-template-entry"); //
      }
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    let data = { ...formData };
    //console.log("formData: ", formData);
    data[name] = value;

    setFormData(data);

    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleChangeTextEditor = (value, field) => {
    //console.log("TextEditor ", value);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: value,
    }));
    setErrorObject((prevErrorObject) => ({
      ...prevErrorObject,
      [field]: null,
    }));

    
  };

  //====== Start Choosen Dropdown===========
  const handleChangeChoosenProps = (name, value) => {
    let data = { ...formData };
    console.log("formData RoleId: ", value);
    data[name] = value;
    setFormData(data);
    //setErrorObject({ ...errorObject, [name]: "" });
    setErrorObject({ ...errorObject, [name]: value.length ? "" : errorObject[name] });

  };
  //====== End Choosen Dropdown===========

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      EventType: "",
      RoleId: [],
      Receivers: "",
      copySMSTo: "",
      mSubject: "",
      MSG: "",
      TemplateMode: "0",
      DryMode: false,
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["EventType",  "mSubject", "MSG"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {

      if (!formData[field] || 
        (field === "MSG" && formData[field] === "<p><br></p>") /* ||
        (field === "RoleId" && Array.isArray(formData[field]) && formData[field].length === 0) */
    ) {
        errorData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }

    });
    setErrorObject(errorData);
    return isValid;
  };

  const handleSubmit = async (e) => {
    //console.log("from submit ", formData);
    if (validateForm(formData)) {
      let fDtat = {
        ...formData,
        menukey: menukey,
        lan: lan,
        UserName: UserName,
      };
      mutate(fDtat);
    }
  };

  return (
    <>
      <EmailSmsTemplateFormData
        errorObject={errorObject}
        addProductForm={true}
        formData={formData}
        handleChange={handleChange}
        handleChangeTextEditor={handleChangeTextEditor}
        handleChangeChoosenProps={handleChangeChoosenProps}
        handleCheck={handleCheck}
        handleReset={handleReset}
        handleSubmit={handleSubmit}
        open={open}
        {...props}
      />
    </>
  );
};

export default AddEmailSmsTemplate;
